export default "__VITE_ASSET__DIRuF1Rf__"